import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import App from "./App";

import StartFromTop from "./helpers/StartFromTop";
import { AppContextProvider } from "./contexts/AppContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <AppContextProvider>
      <StartFromTop />
      <App />
    </AppContextProvider>
  </BrowserRouter>,
);
